import { useReactToScrollButtons } from '@assets/hooks/useReactToScrollButtons';
import { useStoreUI } from '@assets/model/Store';
import { observer } from 'mobx-react';
import { useRef } from 'react';
import * as style from './DealSearchGrid.module.less';

interface DealSearchGridProps {
    deals: React.ReactNode[];
}

export const DealSearchVirtualized = observer((props: DealSearchGridProps) => {
    const scrollRef = useRef<HTMLDivElement>(null);
    const uiStore = useStoreUI();

    useReactToScrollButtons(scrollRef.current, uiStore);

    return (
        <div ref={scrollRef} className={style.scrollContainer}>
            <div className={style.grid}>{props.deals}</div>
        </div>
    );
});
